// Wrapper SDK CrazyGames v3 — 100% sûr en mode standalone (destinexpress.com).
// Toutes les fonctions dégradent gracieusement quand le SDK est absent.

const sdk = () => (typeof window !== "undefined" ? window.CrazyGames?.SDK ?? null : null);

let _available = false;

export const isCrazyGames = () => _available;

export async function initCrazyGames() {
  const s = sdk();
  if (!s) {
    _available = false;
    return false;
  }
  try {
    await s.init();
    // Sur destinexpress.com le SDK s'initialise mais reste "disabled".
    // On n'active les pubs/événements réels que sur CrazyGames (ou en test local).
    const env = s.environment;
    _available = env === "crazygames" || env === "local";
    return _available;
  } catch (e) {
    console.warn("CrazyGames SDK indisponible", e);
    _available = false;
    return false;
  }
}

function gameCall(method) {
  const s = sdk();
  const fn = s?.game?.[method];
  if (!_available || !fn) return false;
  try {
    fn.call(s.game);
    return true;
  } catch (e) {
    console.warn(`CrazyGames ${method}`, e);
    return false;
  }
}

export const loadingStart = () => gameCall("loadingStart");
export const loadingStop = () => gameCall("loadingStop");
export const gameplayStart = () => gameCall("gameplayStart");
export const gameplayStop = () => gameCall("gameplayStop");

// Demande une pub vidéo. `type` = "rewarded" | "midgame".
// callbacks: { onStarted, onFinished, onError }. Renvoie false si le SDK n'est pas dispo.
export function requestVideoAd(type, { onStarted, onFinished, onError } = {}) {
  const ad = sdk()?.ad;
  if (!_available || !ad?.requestAd) {
    onError?.({ code: "sdk-unavailable" });
    return false;
  }
  try {
    ad.requestAd(type, {
      adStarted: () => onStarted?.(),
      adFinished: () => onFinished?.(),
      adError: (error, errorData) => onError?.(errorData ?? error),
    });
    return true;
  } catch (error) {
    onError?.(error);
    return false;
  }
}

export const requestRewardedAd = (callbacks) => requestVideoAd("rewarded", callbacks);
export const requestMidgameAd = (callbacks) => requestVideoAd("midgame", callbacks);
